import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Antes no sabía qué cocinar y terminaba comiendo siempre lo mismo. Ahora tengo recetas simples, saludables y organizadas para toda la semana.',
    name: 'Camila M.',
    role: 'Buenos Aires — Mamá y celíaca',
    initial: 'C'
  }, {
    quote: 'Las planillas y horarios me ayudaron muchísimo. Dejé de improvisar comidas y mi digestión mejoró un montón.',
    name: 'Lucas R.',
    role: 'Rosario — Vida saludable sin gluten',
    initial: 'L'
  }, {
    quote: 'Pensaba que comer sin gluten era aburrido. Este sistema me mostró opciones fáciles, ricas y prácticas para todos los días.',
    name: 'Valentina F.',
    role: 'Córdoba — Alimentación consciente',
    initial: 'V'
  }];
  return <section className="py-16 px-4 bg-warm-white" data-id="element-184">
      <div className="max-w-6xl mx-auto" data-id="element-185">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-186">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.5
        }} className="bg-cream p-8 rounded-3xl shadow-warm border border-sage/10 flex flex-col h-full" data-id="element-187">
              <div className="flex gap-1 mb-6" data-id="element-188">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-terracotta text-terracotta" data-id="element-189" />)}
              </div>
              <p className="text-charcoal text-lg italic mb-8 flex-grow" data-id="element-190">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-191">
                <div className="w-12 h-12 rounded-full bg-sage/20 text-forest flex items-center justify-center font-serif font-bold text-xl" data-id="element-192">
                  {t.initial}
                </div>
                <div data-id="element-193">
                  <div className="font-bold text-forest" data-id="element-194">{t.name}</div>
                  <div className="text-sm text-muted" data-id="element-195">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}